<template>
    <div :class="{ loading: communicating }" v-if="!loading">
        <div v-if="!callInProgress">
            <div class="-mb-2" data-testid="generate-call-to-number-section">
                <p class="flex flex-col" data-testid="generate-call-to-number-label">
                    {{ lead.lead_phones.length ? $t('call.toNumber') : $t('call.toNumber2') }}
                    <span
                        class="text-red-500 text-sm"
                        v-text="$t('call.notPreferredPhone')"
                        v-show="preferredPhone && preferredPhone.id !== leadPhone"
                    />
                </p>
                <communication-method-selection
                    class="mb-2 space-y-2"
                    data-testid="generate-call-to-number-options"
                    name="leadPhone"
                    :disabled="communicating"
                    :items="leadPhoneOptions"
                    :value="leadPhone"
                    :preferred-id="preferredPhone ? preferredPhone.id : null"
                    @input="$emit('update:leadPhone', $event)"
                />
            </div>

            <hr />

            <div class="-mb-2" data-testid="generate-call-from-number-section">
                <p data-testid="generate-call-from-number-label">
                    {{ userPhoneOptions.length ? $t('call.fromNumber') : $t('call.fromNumber2') }}
                </p>

                <communication-method-selection
                    class="mb-2 space-y-2"
                    data-testid="generate-call-from-number-options"
                    name="userPhone"
                    :disabled="communicating"
                    :items="userPhoneOptions"
                    :value="userPhone"
                    @input="$emit('update:userPhone', $event)"
                />
            </div>
        </div>

        <div v-else>
            <div class="-mb-2" style="white-space: pre-line" v-if="recordingConsentScript">
                <p class="mb-4 font-bold">{{ $t('call.recordingConsentTitle') }}</p>
                {{ recordingConsentScript }}
            </div>
        </div>
    </div>
</template>

<script>
    import CommunicationMethodSelection from '@/components/CommunicationMethodSelection.vue';

    export default {
        emits: ['update:leadPhone', 'update:userPhone'],

        components: {
            CommunicationMethodSelection,
        },
        props: {
            leadPhoneOptions: {
                type: Array,
                required: true,
            },
            userPhoneOptions: {
                type: Array,
                required: true,
            },
            leadPhone: {
                validator: (prop) => typeof prop === 'number' || prop === null,
                required: true,
            },
            userPhone: {
                validator: (prop) => typeof prop === 'number' || prop === null,
                required: true,
            },
            communicating: {
                type: Boolean,
                required: true,
            },
            callInProgress: {
                type: Boolean,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true,
            },
            lead: {
                type: Object,
                required: true,
            },
            recordingConsentScript: {
                type: String,
            },
        },

        computed: {
            preferredPhone() {
                return this.lead.phones.find((phone) => phone.preferred) || null;
            },
        },
    };
</script>
